<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    name: "mineAddress",
    data() {
        return {
            list: [],
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        data: {
            immediate: true,
            handler(val) {
                if (!Array.isArray(val)) {
                    this.list = [];
                    return;
                }
                this.list = val;
            },
        },
    },
    methods: {},
};
</script>

<template>
    <div class="table address">
        <div class="item thead only_pc">
            <div class="tr">
                <div class="td">收货人</div>
                <div class="td">电话/手机</div>
                <div class="td">所在地区</div>
                <div class="td">详细地址</div>
                <div class="td">操作</div>
                <div class="td">移动设置</div>
            </div>
        </div>
        <div class="item" v-for="(item, index) in list" :key="index">
            <!-- pc -->
            <div class="tr only_pc">
                <div class="td layout_flex_center">{{ item.name }}</div>
                <div class="td layout_flex_center">{{ item.phone }}</div>
                <div class="td layout_flex_center">{{ item.area }}</div>
                <div class="td layout_flex_center">{{ item.address }}</div>
                <div class="td layout_flex_center">
                    <div class="flex links">
                        <div class="btn" @click="$emit('edit', index)">修改</div>
                        <div class="btn" @click="$emit('delete', item.id)">删除</div>
                        <div class="btn" @click="$emit('top', index)">
                            <span v-if="item.is_top == 1">取消置顶</span>
                            <span v-else>置顶</span>
                        </div>
                    </div>
                </div>
                <div class="td layout_flex_center">
                    <div class="flex links">
                        <div class="btn" :class="{active: item.is_default == 1}">
                            <span v-if="item.is_default == 1">默认地址</span>
                            <span v-else @click="$emit('setDefault', index)">设为默认</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- mobile -->
            <div class="only_mobile">
                <p class="region">{{ item.area }}</p>
                <div class="content">
                    <p class="address">{{ item.address }}</p>
                    <div class="btn" @click="$emit('edit', index)"><img src="@/assets/images/icon_edit.png" alt="编辑"/></div>
                </div>
                <div class="info flex align_center">
                    <p class="name">{{ item.name }}</p>
                    <p class="phone">{{ item.phone }}</p>
                    <p class="is_default" v-if="item.is_default == 1">默认</p>
                    <p class="del" @click="$emit('delete', item.id, true)">删除</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@import './table.scss';
.address{
    .only_mobile{
        .region{
            font-size: .25rem;
            color: #999;
        }
        .content{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: .2rem 0;
            .address{
                font-size: .28rem;
                color: var(--font_color);
            }
            .btn{
                width: .33rem;
                height: .33rem;
                flex-shrink: 0;
                margin-left: .2rem;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .info{
            gap: .2rem;
            line-height: 1;
            .name,
            .phone{
                font-size: .25rem;
                color: #999;
            }
            .is_default{
                font-size: .18rem;
                color: #ff0000;
                background: rgba($color: #ce4e4e, $alpha: .14);
                width: .46rem;
                height: .28rem;
                line-height: .28rem;
                text-align: center;
                border-radius: .04rem;
            }
        }
    }
    .links{
        gap: .1rem;
        .btn{
            cursor: pointer;
            &:hover{
                color: var(--font_color);
            }
            &.active{
                color: #ff0000;
                cursor: auto;
            }
        }
    }
    .thead{
        .tr{
            color: var(--font_color);
        }
    }
    .tr{
        color: #999;
        .td{
            flex: 1;
            &:nth-of-type(2),
            &:nth-of-type(5){
                flex: 2;
            }
            &:nth-of-type(3),
            &:nth-of-type(4){
                flex: 3;
            }
            &:nth-of-type(6){
                flex: 1.5;
            }
        }
    }
}
</style>